import React from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./filterHeader.module.css";

interface FilterHeaderProps {
    onClose: () => void;
    title?: string;
}

export const FilterHeader = ({ onClose, title = "Filters" }: FilterHeaderProps) => (
    <div className={styles.filterPopupHeader}>
        <span className={styles.filterPopupHeaderTitle}>{title}</span>
        <IconButton
            onClick={onClose}
            disableRipple
            disableFocusRipple
            className={styles.closeBtn}
        >
            <CloseIcon />
        </IconButton>
    </div>
);
